export default __webpack_public_path__ + "static/media/Armbands of the Living Tarim.bc5fbb88.jpg";